export default function HandleErrorCodes (codeError){
    switch(codeError){
        case 'eCl00006':
            return 'Hubo un error al hacer la migración. Favor de comunicarse al Call Center.';
        case 'eCl00014':
            return 'Lo sentimos, el correo electrónico proporcionado no está registrado.';
        case 'eCl00025':
            return "Lo sentimos, las respuestas fueron incorrectas, actualiza tu información entrando a la sección 'Preguntas Secretas'";
        case 'eCl00026':
            return 'La contraseña nueva no puede ser la misma que una contraseña utilizada previamente.';
        case 'eCl00088':
            return 'Lo sentimos, el correo electrónico proporcionado no está registrado.'
        default:
            return 'Error: ' + codeError
    }
}


// WEBPACK FOOTER //
// ./src/generalcomponets/handleErrorCodes/index.js